import api from './api';

const videoMetadataService = {
  async fetchMetadata(url) {
    const response = await api.get(`/api/video/metadata?url=${encodeURIComponent(url)}`);
    return response;
  }
};

export default videoMetadataService;
